import React from "react"
import './JuryCard.scss'

function JuryCard({ type, name, description, last = false }) {

    return (
        <div className={`jury-card ${last && 'card-last'}`}>
            <div className={`type-item type-${type}`}>{type === 'jury' ? 'Член жюри' : 'Приглашенный эксперт'}</div>
            <div className="name">{name}</div>
            <div className="description">{description}</div>
        </div >
    );
}

export default JuryCard;